import gql from 'graphql-tag';

const GET_EXTERNAL_ISSUES = gql`
    query getExternalIssuesLogs($size: Int, $page: Int, $filters: filterExternalIssueInput) {
        getExternalIssuesLogs(size: $size, page: $page, filters: $filters) {
            internalCode
            totalCount
            payload {
                id
                saleChannelId
                storeFlag
                isTurningOn
                turnedOnBy
                turnedOnAt
                turnedOffBy
                turnedOffAt
                issueId
            }
        }
    }
`;

export default GET_EXTERNAL_ISSUES;
